import React from 'react';

import { errorCatch, POST, deleteInArray } from 'fennec-ui'
import { useSelector } from 'react-redux';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import AbstractCollection from '../../../common/AbstractCollection';
import NovieDatiVozvratov from '../NovieDatiVozvratov';
import IzmenitDatiVozvratov from '../IzmenitDatiVozvratov';

dayjs.locale('ru');

export default function DativozvratovNaMeropriyatii(props) {
    const { auth, object, sourceKey, queryFilterContext } = props;
    const meta = useSelector(state => state.meta);
    return (
        <>
            <AbstractCollection
                auth={auth}
                noPrint={true}
                noPagination={true}
                size="small"

                source={"/papi/fed/dativozvratov/bymeropriyatie/" + object.ID}

                // filters={() => [
                //     {
                //         name: 'Активная',
                //         value: item => !item.komissiyaPartneram.notActive, //(item.notActive) ? "Да" : "Нет",
                //         field: "active",
                //         type: "bool",
                //         filter: true,
                //         sort: true
                //     },
                //     {
                //         name: 'Неактивная',
                //         value: item => item.komissiyaPartneram.notActive, //(item.notActive) ? "Да" : "Нет",
                //         field: "notActive",
                //         type: "bool",
                //         filter: true
                //     }
                // ]}
                columns={() => [
                    {
                        title: 'Дата',
                        render: (text, record) => {
                            return (dayjs(record.dataVremya).format("DD.MM.YYYY HH:mm"));
                        }
                    },
                    {
                        title: 'Процент к возврату',
                        render: (text, record) => {
                            return (record.protsent);
                        }
                    }
                ]}
                collectionActions={() => [
                    {
                        action: {
                            method: "POST",
                            path: "/api/dativozvratov/new",
                            mutation: "update",
                            onValues: (values) => {
                                return { ...values, meropriyatieID: object.ID }
                            },
                            onClose: ({ close }) => {
                                close();
                            }
                        },

                        form: NovieDatiVozvratov,
                        triggerOptions: {
                            type: "primary"
                        },
                        // form: Model,
                        // meta: GetMetaProperties(meta["DatiVozvratov"], ["meropriyatieID", "meropriyatie"]),
                        options: {
                            initialValues: {},
                        },
                        title: "Новая дата",
                        modal: {
                            minWidth: "250px",
                            title: "Новая дата возврата",
                        }
                    }
                ]}
                modelActions={(item) => [
                    {
                        title: "Изменить",
                        modal: {
                            minWidth: "250px",
                            title: "Изменить дату возврата",
                        },
                        action: {
                            method: "POST",
                            path: "/api/dativozvratov/update",
                            mutation: "update",
                            onValues: (values) => {
                                return { ...values, ID: item.ID, meropriyatieID: object.ID }
                            },
                            onClose: ({ close }) => close()
                        },

                        form: IzmenitDatiVozvratov,
                        // form: Model,
                        // meta: GetMetaProperties(meta["DatiVozvratov"], ["meropriyatieID", "meropriyatie"]),
                        options: {
                            initialValues: {
                                ...item
                            },
                        },
                        object: item,
                        sourceKey: sourceKey,
                        queryFilterContext: queryFilterContext,
                    },
                    {
                        title: "Удалить",
                        action: (values, unlock, close, { collection, setCollection }) => {
                            POST(auth, '/api/dativozvratov/delete', { ...item },
                                () => setCollection(deleteInArray(collection, item)), errorCatch
                            );
                        },
                    }
                ]}
            />
        </>
    );
}
